export enum ScreenSizes {
  tabletAndDesktop = 1280,
}
